import { CookiesConsentComponent } from './cookies/cookies-consent/cookies-consent.component';
import { GridContentComponent } from './home/grid-content/grid-content.component';
import { BannersSidenavComponent } from './banners/banners-sidenav/banners-sidenav.component';
import { BannersHeaderComponent } from './banners/banners-header/banners-header.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HandleHttpResponseInterceptor } from '../shared/interceptors/handle-http-response.interceptor';
import { HandleHttpRequestInterceptor } from '../shared/interceptors/handle-http-request.interceptor';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { TemplateComponent } from './template/template.component';
import { Error404Component } from './error-404/error-404.component';
import { Error403Component } from './error-403/error-403.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CookiesComponent } from './cookies/cookies.component';
import { RememberPasswordComponent } from './header/dialogs/remember-password/remember-password.component';
import { SigninComponent } from './header/dialogs/signin/signin.component';
import { CoreService } from './core.service';
import { SigninService } from './header/dialogs/signin/signin.service';
import { RememberPasswordService } from './header/dialogs/remember-password/remember-password.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { AuthModule } from '../auth/auth.module';
import { CoreRoutingModule } from '@web/project/core/core-routing.module';
import { HomeComponent } from './home/home.component';
import { MenuSidenavComponent } from './menu/menu-sidenav/menu-sidenav.component';
import { MenuMobileComponent } from './menu/menu-mobile/menu-mobile.component';
import { MenuHeaderComponent } from './menu/menu-header/menu-header.component';
import { MenuMobileItemComponent } from './menu/menu-mobile/menu-mobile-item/menu-mobile-item.component';
import { MenuSidenavItemComponent } from './menu/menu-sidenav/menu-sidenav-item/menu-sidenav-item.component';
import { MenuHeaderItemComponent } from './menu/menu-header/menu-header-item/menu-header-item.component';
import { MenuService } from './menu/menu.service';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { PopupDialogComponent } from './popup-dialog/popup-dialog.component';
import { ListContentComponent } from './home/list-content/list-content.component';
import { HeaderService } from './header/header.service';
import { CollegiateUpdateComponent } from './template/dialogs/collegiate-update/collegiate-update.component';
import { ChatComponent } from './chat/chat.component';
import { OpenaiService } from '../shared/openai.service';

@NgModule({
  exports: [
    HeaderComponent,
    RememberPasswordComponent,
    SigninComponent,
    FooterComponent,
    CookiesComponent,
    TemplateComponent,
    Error404Component,
    Error403Component,
    HomeComponent,
    MenuSidenavComponent,
    MenuMobileComponent,
    MenuHeaderComponent,
    MenuMobileItemComponent,
    MenuSidenavItemComponent,
    MenuHeaderItemComponent,
    BreadcrumbComponent,
    BannersHeaderComponent,
    BannersSidenavComponent,
    CollegiateUpdateComponent,
    ChatComponent
  ],
  declarations: [
    HeaderComponent,
    RememberPasswordComponent,
    SigninComponent,
    FooterComponent,
    CookiesComponent,
    CookiesConsentComponent,
    TemplateComponent,
    Error404Component,
    Error403Component,
    HomeComponent,
    MenuSidenavComponent,
    MenuMobileComponent,
    MenuHeaderComponent,
    MenuMobileItemComponent,
    MenuSidenavItemComponent,
    MenuHeaderItemComponent,
    BreadcrumbComponent,
    PopupDialogComponent,
    BannersHeaderComponent,
    BannersSidenavComponent,
    GridContentComponent,
    ListContentComponent,
    CollegiateUpdateComponent,
    ChatComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    OverlayModule,
    SharedModule.forRoot(),
    AuthModule,
    RouterModule,
    CoreRoutingModule
  ],
  providers: [
    CoreService,
    SigninService,
    RememberPasswordService,
    MenuService,
    HeaderService,
    OpenaiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HandleHttpResponseInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HandleHttpRequestInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule { }
